<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('Delete') }}</h5>
                    <button type="button" class="btn-close" data-dismiss="modal" @click="close" aria-label="Close" />
                </div>
                <div class="modal-body">
                    <p >{{ $t('wannaDeleteThisModelingResult') }}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                        {{ $t('close') }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="deleteModelingResult" >
                        {{ $t('delete') }}
                    </button>
                </div>
                </div>
            </div>
        </div>      
    </transition>
</template>

<script>
import analysisApi from "../../api/server/analysis";

export default {
    name: "modelingResultDeleteModal",
    methods: {
        close() {
            this.$emit("close");
        },
        async deleteModelingResult() {
            await analysisApi.analysisDelete(this.$parent.$route.params.id, this.$parent.modelingResultIdToDelete);
            this.$emit("confirm");
        }
    }
}
</script>